
export const CART_STORAGE_KEY = 'cart';